import "@lottiefiles/lottie-player";
import {menu, navigation} from "./modules/Menu.js";
import {setHeaderHeight} from "./modules/setHeaderHeight.js";
import {scrollDown} from "./modules/scrollDown.js";
import {openSearchbox} from "./modules/openSearchbox.js";
import {media} from "./modules/media.js";
import {
	heroslider,
	cardslider,
	productimagesslider,
	galleryslider,
	subCatSwiper,
	productsslider,
	plattenformenslider,
	serienproductsslider
} from "./modules/swiper.js";
import {bommel} from "./modules/bommel.js";
import {animations} from "./modules/animations.js";
import {map} from "./modules/map.js";
import {contactPopup} from "./modules/contactPopup.js";
import {popup} from "./modules/popup.js";
import {form} from "./modules/form.js";
import {contrastSwitch} from "./modules/contrastSwitch.js";
import {toggleShopFilter} from "./modules/toggleShopFilter.js";
import {popupProducts} from "./modules/popup-products.js";
import {footer} from "./modules/footer.js";
import {blockAccordion} from "./blocks/accordions.js";
import {auszeichnungen} from "./blocks/auszeichnungen.js";
import {cta} from "./blocks/cta.js";
import {einleitungstext} from "./blocks/einleitungstext.js";
import {iconteaser} from "./blocks/iconteaser.js";
import {interactiveshowcase} from "./blocks/interactiveshowcase.js";
import {kundenstimmen} from "./blocks/kundenstimmen.js";
import {vertriebler} from "./blocks/vertriebler.js";
// import {ajaxloadmore} from "./modules/ajax-loadmore.js";

import.meta.glob([
	'../images/**',
	'../fonts/**',
]);


document.addEventListener('DOMContentLoaded', function () {
	setHeaderHeight();
	menu();
	navigation();
	scrollDown();
	openSearchbox();
	media();
	heroslider();
	cardslider();
	bommel();
	animations();
	productimagesslider();
	galleryslider();
	map();
	contactPopup();
	productsslider();
	popup();
	form();
	contrastSwitch();
	toggleShopFilter();
	popupProducts();
	plattenformenslider();
	serienproductsslider();
	subCatSwiper();
	footer();
	// ajaxloadmore();
	blockAccordion();
	auszeichnungen();
	cta();
	einleitungstext();
	iconteaser();
	interactiveshowcase();
	kundenstimmen();
	vertriebler();


}, false);




jQuery(($) => {
	const $btn = $('#load-more');
	const $container = $('#post-container');
	const $sort = $('#sort-order');

	if ($btn.length) {
		let page = parseInt($btn.data('page'), 10) || 1;
		const postType = $btn.data('post-type');
		const taxonomy = $btn.data('taxonomy');
		const term = $btn.data('term');
		let sort = $sort.length ? $sort.val() : 'date_desc';

		function loadPosts(reset = false) {
			if (reset) {
				page = 1;
				$container.html('');
			} else {
				page++;
			}

			$btn.text('Lädt ...');

			const params = new URLSearchParams({
				page,
				post_type: postType,
				sort,
			});
			if (taxonomy && term) {
				params.append('taxonomy', taxonomy);
				params.append('term', term);
			}

			fetch(`/wp-json/sage/v1/archive?${params.toString()}`).then((res) => res.json()).then((data) => {
				if (reset) $btn.show(); // Button zurückholen beim Sortieren
				if (data.html && data.html.trim() !== '') {
					$container.append(data.html);
					if (page >= data.max) {
						$btn.remove();
					} else {
						$btn.text('Mehr laden');
					}
				} else {
					$btn.remove();
				}
			}).catch((err) => {
				console.error(err);
				$btn.text('Fehler');
			});
		}

		$btn.on('click', () => loadPosts(false));

		if ($sort.length) {
			$sort.on('change', function () {
				sort = $(this).val();
				$btn.text('Mehr laden');
				loadPosts(true);
			});
		}
	}
});


document.addEventListener("DOMContentLoaded", function () {
	const breadcrumb = document.querySelector(".rank-math-breadcrumb p");
	if (!breadcrumb) return;

	const maxVisible = 2; // die letzten 2 bleiben immer sichtbar
	const items = [...breadcrumb.querySelectorAll("a, .last")];
	const separators = [...breadcrumb.querySelectorAll(".separator")];

	function truncateBreadcrumb() {
		// console.log("Test");
		// Reset
		items.forEach(el => (el.style.display = ""));
		separators.forEach(el => (el.style.display = ""));

		const ellipsis = breadcrumb.querySelector(".breadcrumbs-ellipsis");

		if (ellipsis) ellipsis.remove();

		// console.log("breadcrumb.scrollWidth: ", breadcrumb.scrollWidth);
		// console.log("breadcrumb.clientWidth: ", breadcrumb.clientWidth);
		// console.log("window.innerWidth: ", window.innerWidth);
		// console.log("breadcrumb.getBoundingClientRect().right: ", breadcrumb.getBoundingClientRect().right);

		// Wenn alles reinpasst, nix tun
		if (breadcrumb.scrollWidth <= breadcrumb.clientWidth) return;

		// if (breadcrumb.clientWidth > window.innerWidth) return;

		// console.log("Test2", items.length);


		if (items.length > 3) {

			const first = items[0]; // Home
			const lastVisibleItems = items.slice(-maxVisible); // letzten 2
			const hiddenItems = items.slice(1, items.length - maxVisible); // alles dazwischen

			hiddenItems.forEach((el, i) => {
				el.style.display = "none";
				if (separators[i + 1]) separators[i + 1].style.display = "none"; // Separator vor dem nächsten
			});

			// Ellipsis + Separator einfügen
			const ellipsisSpan = document.createElement("span");
			ellipsisSpan.textContent = "…";
			ellipsisSpan.className = "breadcrumbs-ellipsis";

			// Separator vor Ellipsis sichtbar machen
			const separatorBefore = separators[hiddenItems.length] || null;
			if (separatorBefore) separatorBefore.style.display = "";

			breadcrumb.insertBefore(ellipsisSpan, lastVisibleItems[0].previousElementSibling);
		}


		// Aktuellen Seitentitel ausblenden, falls mehr als 2 Links
		if (items.length > 2) {
			const lastItem = breadcrumb.querySelector(".last");
			if (lastItem) {
				lastItem.style.display = "none";

				// Separator direkt davor ebenfalls ausblenden
				const lastSeparator = lastItem.previousElementSibling;
				if (lastSeparator && lastSeparator.classList.contains("separator")) {
					lastSeparator.style.display = "none";
				}
			}
		}

	}

	// Initial prüfen + bei Resize reagieren
	truncateBreadcrumb();
	window.addEventListener("resize", truncateBreadcrumb);
});






